/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_Consent_UnavailableInputs */

const en_checkout_consent_unavailable = /** @type {(inputs: Checkout_Consent_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't load the booking terms. Please contact us to complete your booking.`)
};

/**
* | output |
* | --- |
* | "We couldn't load the booking terms. Please contact us to complete your booking." |
*
* @param {Checkout_Consent_UnavailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const checkout_consent_unavailable = /** @type {((inputs?: Checkout_Consent_UnavailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Consent_UnavailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_checkout_consent_unavailable(inputs)
});